import React, {useState, useEffect, useRef} from 'react';
import FormData from './IncurredShow';
import VerifyModal from './components/modals/VerifyModal';
import './addPotentionalRisk.scss';

const ShowIncurredRisk = ({
  defaultData,
  isModalVerifyOpen,
  setIsModalVerifyOpen,
}) => {

  return (
    <div style={{width: '100%'}}>
      <FormData defaultData={defaultData} />
      <VerifyModal
        open={isModalVerifyOpen}
        id={defaultData?.id}
        isOpen={(e) => setIsModalVerifyOpen(e)}
      />
    </div>
  );
};

export default ShowIncurredRisk;
